import React, {useState, useEffect} from 'react';
import Papa from 'papaparse';
import nl2br from 'react-nl2br';
import Linkify from 'react-linkify';

function App({filterFile, dataFile}) {
  filterFile = filterFile || 'departments.csv';
  dataFile = dataFile || 'data.csv';

  const [header, setHeader] = useState([]);
  const [data, setData] = useState(null);
  const [filter, setFilter] = useState('');
  const [filterConfig, setFilterConfig] = useState(emptyFilterConfig);

  useEffect(() => {
    loadData(dataFile, ({header, data}) => {
      setHeader(header);
      setData(data);
    });
  }, [dataFile]);

  useEffect(() => {
    loadFilterConfig(filterFile, setFilterConfig);
  }, [filterFile]);

  if (data === null) {
    return <div>Loading...</div>
  }

  let filteredData = [];
  if (filter !== '') {
    filteredData = data.filter(record => record[filterConfig.column] === filter);
  }

  return (
    <div className="table-responsive-md">
      <Filter filter={filter} filterConfig={filterConfig} setFilter={setFilter} />
      <Table header={header} data={filteredData} />
    </div>
  );
}

const emptyFilterConfig = {
  column: '',
  label: '',
  values: [],
}

function loadFilterConfig(file, callback) {
  loadData(file, ({data}) => {
    const row = data.shift();
    const config = {
      column: row.code,
      label: row.name,
      values: data,
    }
    callback(config);
  });
}

function Filter({filterConfig, filter, setFilter}) {
  const {label, values} = filterConfig;

  return (
    <div className="form-group mt-3">
      <select className="form-control col-md-4" value={filter} onChange={(event => setFilter(event.target.value))}>
        <option value="">{label}</option>
        {values.map((d, i) => (
          <option key={i} value={d.name}>{d.code}. {d.name}</option>
        ))}
      </select>
    </div>
  );
}

function Table({header, data}) {
  return (
    <table className="table table-striped table-sm table-bordered">
      <thead className="thead-dark">
        <tr>
          {header.map((field, i) => <th key={i}>{field}</th>)}
        </tr>
      </thead>
      <tbody>
        {data.map((record, i) => (
          <tr key={i}>
            {header.map((field, j) => <td key={j}><Field content={record[field]} /></td>)}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function Field({content}) {
  return <Linkify>{nl2br(content)}</Linkify>;
}

function loadData(filePath, callback) {
  Papa.parse(filePath, {
    download: true,
    delimiter: ';',
    header: true,
    skipEmptyLines: true,
    complete: (results, file) => {
      console.log(results);
      callback({data: results.data, header: results.meta.fields});
    },
  });
}

export default App;
